// @ts-check

import { degToRad, finiteNumber } from '../../shared/math.js?v=20260706d';

export { degToRad };

export function rotatePointAroundPivot(point, pivot, angleDeg = 0) {
  const rad = degToRad(angleDeg);
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  const x = finiteNumber(point?.x, 0);
  const z = finiteNumber(point?.z, 0);
  const pivotX = finiteNumber(pivot?.x, 0);
  const pivotZ = finiteNumber(pivot?.z, 0);
  const dx = x - pivotX;
  const dz = z - pivotZ;
  return {
    x: pivotX + dx * cos - dz * sin,
    z: pivotZ + dx * sin + dz * cos
  };
}
